import React from "react";
import { navigate } from "gatsby";
import { inject, observer } from "mobx-react";
import { AuthenticationStore } from "src/stores";

export interface PrivateRouteProps {
  path: string;
  component: any;
  authenticationStore?: AuthenticationStore;
}

@inject("authenticationStore")
@observer
export class PrivateRoute extends React.Component<PrivateRouteProps> {
  componentDidMount() {
    const {
      authenticationStoreHydrated,
      userHasValidToken
    } = this.props.authenticationStore;
    if (
      location.pathname !== `/gated/gatedInfoPage` &&
      authenticationStoreHydrated &&
      !userHasValidToken
    ) {
      navigate("/gated/gatedInfoPage");
    }
  }
  render() {
    const { component, ...rest } = this.props;
    const Comp = component;
    return <Comp {...rest} />;
  }
}
